<template>
  <div>
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="showWeather = !showWeather">
                  {{ $t('weather_station.data_title') }} ({{ contractWeatherData.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="showWeather = !showWeather">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:showWeather }"/>
          </div>
      </div>
      <div v-if="weatherTableData && weatherTableData.length > 0" class="routa-collapse" :class="{ collapsed: showWeather }">
          <vue3-datatable
              ref="resultTable"
              :rows="weatherTableData"
              :columns="weatherTableFields"
              :pagination="false"
              :sticky-header="true"
              height="55vh"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="weatherTableRowClicked"
          >
              <template #time="row">
                  {{ row.value.localTime }}
              </template>
              <template #airTemperature="row">
                  {{ row.value.airTemperature.value }}{{ row.value.airTemperature.unit }}
              </template>
              <template #roadTemperature="row">
                  {{ row.value.roadTemperature.value }}{{ row.value.roadTemperature.unit }}
              </template>
              <template #stationName="row">
                  {{ row.value.stationName }}
              </template>
              <template #rain="row">
                  {{ getRainTypeText(row.value.rain.value) }}
              </template>

          </vue3-datatable>

      </div>
      <weather-position-details-modal
          v-model="stationData"
          :weather-station="stationData"
          @cancel="stationData = null"
      />

      <hr class="report-divider nopads">
  </div>

</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import WeatherPositionDetailsModal from "@/components/weather/WeatherPositionDetailsModal.vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {weatherHelper} from "@/components/mixins/WeatherMixin";

export default {
    name: "WeatherTrackingPositionDetails",
    components: {WeatherPositionDetailsModal, Vue3Datatable},
    mixins: [restApi, timeUtils, weatherHelper],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
    },
    data() {
        return {
            loading: false,
            showWeather: false,
            contractWeatherData: [],
            stationData: null,
            modalTitle: '',
        }
    },
    computed: {
        weatherTableFields() {
            return [
                {field: 'time', title: this.$t('weather_station.updated_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'airTemperature', title: this.$t('weather_station.sensor_data.air_temperature'), sort: true, headerClass: 'routa-table-header'},
                {field: 'roadTemperature', title: this.$t('contracts.external.road_temp'), sort: true, headerClass: 'routa-table-header'},
                {field: 'rain', title: this.$t('contracts.external.rain_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'stationName', title: this.$t('weather_station.name'), sort: true, headerClass: 'routa-table-header'},
            ]
        },
        weatherTableData() {
            return this.contractWeatherData.map((d, dataIndex) => (
                {
                    dataIndex,
                    time: new Date(d.data_updated_time).getTime(),
                    airTemperature: d.sensor_values.find(v => v.name === "ILMA"),
                    roadTemperature: d.sensor_values.find(v => v.name === "TIE_1"),
                    rain: d.sensor_values.find(v => v.name === "SATEEN_OLOMUOTO_PWDXX"),
                    stationName: d.station.name,
                    localTime: this.toLocalTime(d.data_updated_time)
                }
            ))
        },
    },
    watch: {
        searchParams() {
            this.fetchContractData()
        },
    },
    mounted() {
        this.fetchContractData()
    },
    methods: {
        weatherTableRowClicked({dataIndex: index}) {
            this.stationData = this.contractWeatherData[index]
            this.modalTitle = this.contractWeatherData[index].station.name
        },
        async fetchContractData() {
            this.contractWeatherData = []
            let { contract, ...params } = this.searchParams;
            if (params.dateFrom != null) {
                params.dateFrom = new Date(params.dateFrom);
            }
            if (params.dateTo != null) {
                params.dateTo = new Date(params.dateTo);
            }

            try {
                this.loading = true;
                const { data } = await this.fetchContractWeatherData(contract, params);
                this.contractWeatherData = data;
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
